var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M20.285 35.532a.938.938 0 00.44-.163c.135-.092.246-.22.333-.382l12.5-26.481c.13-.293.182-.548.155-.765a.806.806 0 00-.26-.52.904.904 0 00-.554-.22 1.394 1.394 0 00-.708.154L5.66 19.606c-.196.087-.342.2-.44.342a.88.88 0 00-.162.448c-.011.157.016.3.081.43.065.131.168.24.31.326.14.087.308.13.504.13l13.183.017c.141 0 .212.07.212.211l.016 13.119c0 .217.044.393.13.529a.794.794 0 00.342.301c.141.065.29.09.448.073zm-.033-.984c-.06-.011-.09-.044-.09-.098l.017-13.346c0-.196-.049-.35-.146-.464-.098-.114-.277-.171-.538-.171l-13.28.016c-.077 0-.115-.027-.115-.081 0-.055.022-.093.065-.114L32.55 7.87c.12-.054.211-.051.277.008.065.06.065.15 0 .269L20.39 34.466c-.033.065-.079.092-.139.082z"
  }))));
}

export default SvgLocation;